import { getIn18Text } from 'api';
import React from 'react';
import { useAppSelector } from '@web-common/state/createStore';
import { getModuleAccessSelector } from '@web-common/state/reducer/privilegeReducer';
import { message } from 'antd';
export const PrivilegeCheck = ({ children, accessLabel, resourceLabel }) => {
    const hasPermisson = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, resourceLabel, accessLabel));
    if ((resourceLabel === 'ADDRESS_BOOK' && accessLabel !== 'EXPORT') || (resourceLabel === 'ADDRESS_OPEN_SEA' && accessLabel !== 'EXPORT')) {
        return React.createElement(React.Fragment, null, children);
    }
    return hasPermisson ? React.createElement(React.Fragment, null, children) : null;
};
export const PermissionCheckPage = ({ children, accessLabel, resourceLabel, menu, customContent }) => {
    const hasPermisson = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, resourceLabel, accessLabel));
    const menuKeys = useAppSelector(state => state.privilegeReducer.visibleMenuLabels);
    const moduleName = location.hash.substring(1).split('?')[0];
    if (menu === 'EDM_MULTI_ACCOUNT_INFO') {
        return hasPermisson && menuKeys[menu] === true ? React.createElement(React.Fragment, null, children) : React.createElement(NoPermissionPage, { children: customContent, moduleName: moduleName });
    }
    return hasPermisson && menuKeys[menu] === true ? React.createElement(React.Fragment, null, children) : React.createElement(NoPermissionPage, { children: customContent, moduleName: moduleName });
};
export const GetModulePart = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
export const usePermissionCheck = (accessLabel, resourceLabel, menu) => {
    const hasPermisson = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, resourceLabel, accessLabel));
    const menuKeys = useAppSelector(state => state.privilegeReducer.visibleMenuLabels);
    return hasPermisson && menuKeys[menu] === true;
};
export const usePermission = (accessLabel, resourceLabel) => {
    const hasPermisson = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, resourceLabel, accessLabel));
    return hasPermisson;
};
export const NoPermissionPage = ({ children, title, moduleName }) => (React.createElement("div", { className: "no-permission-page", style: { height: moduleName === 'enterpriseSetting' ? 'calc(100% - 56px)' : '100%' } },
    React.createElement("div", { className: "sirius-no-permission" }),
    React.createElement("div", { className: "text" }, title || '暂无权限，请联系相应管理员进行设置'),
    children));
export const PrivilegeCheckForMailPlus = ({ children, accessLabel, resourceLabel }) => {
    const hasPermisson = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, resourceLabel, accessLabel));
    const noPermissonToast = true;
    if (hasPermisson) {
        return React.createElement(React.Fragment, null, children);
    }
    if (noPermissonToast) {
        return (React.createElement(React.Fragment, null, React.Children.map(children, child => React.cloneElement(child, {
            onClick: (event) => {
                (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
                (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
                message.info(getIn18Text('NINHAIMEIYOUCAOZUOQUAN'));
            },
        }))));
    }
    return null;
};
